import cloneDeep from 'lodash/cloneDeep';

import { SORT_DIRECTION } from '@common/constants';
import client from '@common/utils/rest';
import { mapToObj } from '@common/utils/map';

const URL_PREFIX = 'fieldsapi/fields';

const normalizeFields = (fields) => {
  const firstFieldValues = Object.values(fields.fieldDetails.lookupValues)[0];
  const rowsAmount = firstFieldValues ? firstFieldValues.length : 0;
  const fieldsId = Object.keys(fields.fieldDetails.lookupValues);
  const data = Array(rowsAmount).fill('').map((x, i) => {
    const rowValue = fieldsId.reduce((acc, fieldId) => {
      const currentFieldValues = fields.fieldDetails.lookupValues[fieldId];

      return {
        ...acc,
        [fieldId]: currentFieldValues[i],
      };
    }, {});

    return rowValue;
  });

  const getFieldDTO = (fieldMetadata) => {
    const { fieldDto, fieldValidationDto, subfields, lookupValues, ...otherData } = fieldMetadata;

    return {
      ...fieldDto,
      ...fieldValidationDto,
      ...otherData,
    };
  };
  const columns = [
    fields.fieldDetails,
    ...fields.subFieldDetails
  ].map(getFieldDTO);
  
  return {
    data,
    columns,
    fields,
  };
};

export const getFields = ({ fieldId, context }, { sorting, updateSort }) => {
  return client({
    params: {
      fieldId,
      context,
      updateSort: updateSort || undefined,
      sortColIndex: sorting.columnIndex || 1,
      sortAsc: sorting.direction ? sorting.direction === SORT_DIRECTION.asc : true,
    },
    path: `${URL_PREFIX}/getFieldDetails`,
    method: 'GET',
  }).then((response) => {
    if (response.entity.responseCode !== 200) {
      return {
        data: [],
        columns: [],
        fields: {},
      };
    }

    const normalizedFields = normalizeFields(response.entity.payLoad);

    return normalizedFields;
  });
};

export const updateField = ({ index, id, value, fields }) => {
  const fieldsCopy = cloneDeep(fields);

  const field = Object.keys(fieldsCopy.fieldDetails.lookupValues).reduce((acc, columnId) => {
    const cellValue = fieldsCopy.fieldDetails.lookupValues[columnId][index];

    return {
      ...acc,
      [columnId]: [cellValue]
    };
  }, {});

  fieldsCopy.oldLookupValues = field;

  const updatedField = {
    ...field,
    [id]: [value]
  };

  fieldsCopy.fieldDetails.lookupValues = updatedField;
  fieldsCopy.updateFieldId = id;

  return client({
    path: `${URL_PREFIX}/updateFieldData`,
    method: 'POST',
    entity: fieldsCopy,
  });
};

export const deleteRow = ({ primaryCell, fields }) => {
  const { fieldDetails } = cloneDeep(fields);
  
  fieldDetails.lookupValues = Object.keys(fieldDetails.lookupValues).reduce((acc, columnId) => {
    if (columnId == primaryCell.id) {
      return {
        ...acc,
        [columnId]: [primaryCell.value],
      };
    }

    return {
      ...acc,
      [columnId]: [''],
    };
  }, {});

  return client({
    path: `${URL_PREFIX}/deleteFieldData`,
    method: 'POST',
    entity: { fieldDetails },
  });
};

export const createRow = ({ primaryCell, fields, columns }) => {
  const { fieldDetails } = cloneDeep(fields);

  fieldDetails.lookupValues = columns.reduce((acc, { id }) => {
    if (id == primaryCell.id) {
      return {
        ...acc,
        [id]: [primaryCell.value],
      };
    }

    return {
      ...acc,
      [id]: [''],
    };
  }, {});

  return client({
    path: `${URL_PREFIX}/addFieldData`,
    method: 'POST',
    entity: { fieldDetails },
  });
};

export const exportData = (data) => {
  const path = `${URL_PREFIX}/exportFieldData`;

  return fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(async (x) => {
    const blob = await x.blob();

    return {
      headers: mapToObj(x.headers),
      entity: blob,
    };
  });
};

export const importData = (data) => {
  data.allowAddRows = true
  const formData = new FormData();


  Object.keys(data).forEach((fieldName) => {
    formData.append(fieldName, data[fieldName]);
  });

  return new Promise(function (resolve, reject) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${URL_PREFIX}/importFieldData`);
    xhr.onload = function () {
      return resolve({
        entity: JSON.parse(xhr.response),
      });
    };

    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
      });
    };
  
    xhr.send(formData);
  });
};